<template>
  <div>
    <div class="face_header">
      <div class="face_header_con">
        <p class="face_header_lf">{{ this.testInfo.examName }}</p>
        <a class="face_header_rg" @click="logoutHandle">
          <span class="headsp"><img src="@/assets/images/exit.png"/></span>
          退出
        </a>
        <router-link to="/profile" class="face_header_rg">
          <span class="headsp"><img src="../assets/images/icon-user.png"/></span
          >{{ this.userInfo.userName }}
        </router-link>
      </div>
    </div>
    <div class="face_con">
      <div class="face_content">
        <div class="face_con_left">
          <h1 class="face_con_tit">
            本次考试需要启用电脑摄像头抓拍监控
            <!-- <p>请调整好摄像头，确保摄像头能够正常显示，并采集到正脸的位置，点击下面按钮开始检测</p> -->
            <div class="face_con_tit">
              <div class="face_yanzhen">
                  <div style="display: inline-block; width: 400px;" v-if="videoDevice.length>1">
                    <a class="camera_item_select" ref="camera1" @click="getCamera(0)">摄像头1</a>
                    <a class="camera_item" ref="camera2" @click="getCamera(1)">摄像头2</a>
                  </div>
                  
                  <video id="videoCamera" style="width:400px;" v-show="openSuccess"></video>
                  <canvas
                    id="canvasCamera"
                    width="100%"
                    style="display: none;"
                  ></canvas>
                  <a v-show="showNext"
                    class="face_yanzhen_btn"
                    href="javascript:void(0);"
                    @click="next"
                    >下一步</a
                  >
                  <div v-show="!openSuccess" style="width:400px;height: 300px; margin: 0 auto; background-color: black;" >
                    <img src="images/error.png" style="width: 50px; margin-top: 50px;">
                    <p style="color:white;padding-top: 20px; width:80%; margin:auto" >{{ errorMsg }}</p>
                  </div>
                  <a v-show="!openSuccess"
                    class="face_yanzhen_btn"
                    href="javascript:void(0);"
                    onClick="location.reload();"
                    >已调整好，重新打开</a
                  >
              </div>
            </div>
            <!-- <p class="yanzhen_con">
              说明：<br />
              如摄像头不能正常显示，请阅读右边的常见问题，或拨打以下电话：<br />
              陈老师13267869678、张老师18022368859
            </p> -->
          </h1>
        </div>
        <div class="face_con_right">
          <h1 class="face_con_tit face_right_tit">常见问题:</h1>
          <p style="margin-top:0px;">
            1、建议使用Edge、谷歌浏览器进行考试，不支持IE浏览器和Safari浏览器
          </p>
          <p>
            2、打开摄像头失败，请按<a
              href="https://examai.cn/pc/zhinan.pdf"
              target="_blank"
              ><font color="red"><b>启用摄像头操作指南</b></font></a
            >进行操作>
          </p>
          <p>
            <font size="3"
              ><b>3、技术支持:<br /><span v-html="description"/></b>
            </font>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// window.addEventListener(
//   "popstate",
//   function(e) {
//     this.closeCamera();
//     console.log(e);
//   },
//   false
// );
import { getExamById, myInfo, logout, sysDescById } from "@/api/login";
import Cookies from "js-cookie";

export default {
  name: "CheckVideo",
  data() {
    return {
      examBean: {
        token: ""
      },
      tokenBean: {
        token: "",
        examUserId: ""
      },
      descBean: {
        token: "",
        id: ""
      },
      userInfo: {},
      testInfo: {},
      examUserId: "",
      imgSrc: "",
      video: null,
      context: null,
      canvas: null,
      openSuccess: true,
      showNext: false,
      errorMsg: "",
      description: "",
      videoDevice:[]  //摄像头设备
    };
  },
  created() {
    this.examBean.token = this.getToken();
    this.examUserId = this.$route.query.examUserId;
    this.tokenBean.token = this.getToken();
    this.tokenBean.examUserId = this.examUserId;
    this.descBean.token = this.getToken();
    this.descBean.id = 14;
    this.initData();
    setTimeout(() => {
      this.getCamera(0);
    }, 1000);

    // 列出设备列表
    // navigator.mediaDevices.enumerateDevices().then(res => console.table(res));
    navigator.mediaDevices.enumerateDevices().then(res => {
      res.forEach(item => {
        console.log(item);
        if(item.kind==='videoinput') {
          this.videoDevice.push(item.deviceId);
        }
      });
    });
    console.log(this.videoDevice);
  },
  destroyed() {
    this.closeCamera();
  },
  methods: {
    initData() {
      myInfo(this.examBean).then(res => {
        if (res.code === 200) {
          console.log(res.data);
          this.userInfo = res.data.user;
        } else {
          this.$message.error(res.data.message);
          return;
        }
      });
      getExamById(this.tokenBean).then(res => {
        if (res.code === 200) {
          this.testInfo = res.data;
        }
      });
      sysDescById(this.descBean).then(res => {
        this.description = res.data.msg;
      });
    },
    readNotice() {
      this.$router.push({
        path: "/examNeedToKnow",
        query: { examUserId: this.tokenBean.examUserId }
      });
    },
    confirmInfo() {
      this.$router.push({
        path: "/confirmProfile",
        query: { examUserId: this.tokenBean.examUserId }
      });
    },

    // 打开摄像头
    getCamera(index) {
      console.log(this.videoDevice[index]);

      //有两个以上摄像头，保存用户选择的摄像头到cookies中
      if(this.videoDevice.length>1) {
        Cookies.set("videoDeviceId",this.videoDevice[index],{expires:1});
      }

      if(this.videoDevice.length>1) {
        if(index===0) {
          this.$refs.camera1.classList.value = "camera_item_select";
          this.$refs.camera2.classList.value = "camera_item";
        }
        else {
          this.$refs.camera1.classList.value = "camera_item";
          this.$refs.camera2.classList.value = "camera_item_select";
        }
      }
      this.video = document.getElementById("videoCamera");
      this.canvas = document.getElementById("canvasCamera");
      this.context = this.canvas.getContext("2d");
      // const errocb = () => {
      //   this.$message.error("摄像头打开失败！");
      //   this.openSuccess = false;
      // };

      // const constraints = { audio: false, video: true };
      const constraints = { audio: false, video: {deviceId:this.videoDevice[index]} };
      let that = this;
      if (navigator.webkitGetUserMedia) {
        console.log('navigator.webkitGetUserMedia');
        
        navigator.webkitGetUserMedia(constraints,function(stream) {
            // video.src=window.URL.createObjectURL(stream);
            that.video.srcObject = stream;
            that.video.play();
            that.openSuccess = true;
            that.showNext = true;
          },
          function(err){
            console.log(err);
            console.log(err.name + ": " + err.message);
            if('NotFoundError' == err.name) {
              //that.$message.error("摄像头打开失败，检测到电脑没有安装摄像头！");
              that.errorMsg = "摄像头打开失败，没有检测到摄像头！";
            }
            else if('NotReadableError' == err.name) {
              //that.$message.error("摄像头打开失败，摄像头故障或正在被其它应用使用，请检查或退出使用摄像头的应用！");
              that.errorMsg = "摄像头打开失败，摄像头故障或正在被其它应用使用！";
            }
            else if('NotAllowedError' == err.name) {
              //that.$message.error("摄像头打开失败，原因是用户拒绝了该网站使用摄像头，请按右边常见问题进行操作！");
              that.errorMsg = "摄像头打开失败，用户拒绝了该网站使用摄像头！";
            }
            else if('AbortError' == err.name) {
              //that.$message.error("摄像头打开失败，摄像头故障或正在被其它应用使用，请检查或退出使用摄像头的应用！");
              that.errorMsg = "摄像头打开失败，摄像头故障或正在被其它应用使用！";
            }
            else {
              //that.$message.error("摄像头打开失败，未知错误！");
              that.errorMsg = "摄像头打开失败，未知错误！";
            }
            that.openSuccess = false;
            that.showNext = false;
          }
        );
      } 
      else if (navigator.mediaDevices.getUserMedia) {
        console.log('navigator.mediaDevices.getUserMedia');

        // const constraints = { audio: false, video: true };
        const constraints = { audio: false, video: {deviceId:this.videoDevice[index]} };
        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
            // var video = document.querySelector('video');
            this.video.srcObject = stream;
            this.video.onloadedmetadata = () => {
              this.video.play();
              that.openSuccess = true;
              that.showNext = true;
            };
          },
          function(err){
            console.log(err);
            console.log(err.name + ": " + err.message);
            if('NotFoundError' == err.name) {
              //that.$message.error("摄像头打开失败，检测到电脑没有安装摄像头！");
              that.errorMsg = "摄像头打开失败，没有检测到摄像头！";
            }
            else if('NotReadableError' == err.name) {
              //that.$message.error("摄像头打开失败，摄像头故障或正在被其它应用使用，请检查或退出使用摄像头的应用！");
              that.errorMsg = "摄像头打开失败，摄像头故障或正在被其它应用使用！";
            }
            else if('NotAllowedError' == err.name) {
              //that.$message.error("摄像头打开失败，原因是用户拒绝了该网站使用摄像头，请按右边常见问题进行操作！");
              that.errorMsg = "摄像头打开失败，用户拒绝了该网站使用摄像头！";
            }
            else if('AbortError' == err.name) {
              //that.$message.error("摄像头打开失败，摄像头故障或正在被其它应用使用，请检查或退出使用摄像头的应用！");
              that.errorMsg = "摄像头打开失败，摄像头故障或正在被其它应用使用！";
            }
            else {
              //that.$message.error("摄像头打开失败，未知错误！");
              that.errorMsg = "摄像头打开失败，未知错误！";
            }
            that.openSuccess = false;
            that.showNext = false;
          }
        );

      } else if (navigator.getUserMedia) {
        console.log('navigator.getUserMedia');
        // const constraints = { audio: false, video: true };
        const constraints = { audio: false, video: {deviceId:this.videoDevice[index]} };
        navigator.getUserMedia(
          constraints,
          stream => {
            this.video.src = window.webkitURL.createObjectURL(stream);
            this.video.srcObject = stream;
            this.video.play();
            that.openSuccess = true;
            that.showNext = true;
          },
          errocb  => {
            this.$message.error("摄像头打开失败！");
            that.openSuccess = false;
            that.showNext = false;
          }
        );
      } else {
        alert("你的浏览器不支持打开摄像头");
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      this.context.drawImage(this.video, 0, 0, 240, 240);
      this.imgSrc = this.canvas.toDataURL("image/png");
      if (this.imgSrc.length > 6000) {
        // 需要后置摄像头实时监控
        if (this.testInfo.backCamera === 2) {
          this.$router.push({
            path: "/backCameraQrcode",
            query: { examUserId: this.examUserId }
          });
          return;
        }

        this.$router.push({
          path: "/examConfirm",
          query: { examUserId: this.examUserId }
        });
      } else {
        // 特例考生
        if (this.userInfo.specialFlag === 1) {
            this.$router.push({
              path: "/examConfirm",
              query: { examUserId: this.examUserId }
            });
            return;
        }
        else {
          alert("检测到摄像头不正常，请重新调整，或切换到别的浏览器");
        }
      }
    },
    // 关闭摄像头
    closeCamera() {
      this.video.srcObject.getTracks()[0].stop();
    },
    logoutHandle() {
      if (confirm("退出确认")) {
        logout(this.examBean).then(res => {
          if (res.code === 200) {
            this.removeUserInfo();
            this.$router.push("/login");
          }
        });
      }
    },

    next() {
      // 需要后置摄像头实时监控
      if (this.testInfo.backCamera === 2) {
        this.$router.push({
          path: "/backCameraQrcode",
          query: { examUserId: this.examUserId }
        });
        return;
      }

      this.$router.push({
        path: "/examConfirm",
        query: { examUserId: this.examUserId }
      });
    }
  }
};
</script>

<style scoped>
.camera_item_select{
  display: block;
    width: 120px;
    line-height: 25px;
    border: 1px solid #D8D8D8;
    text-align: center;
    margin-left: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
    cursor: pointer;
    float: left;
    background: #208be6;
    color: #FFF;
    font-size: 16px;
}

.camera_item{
  display: block;
    width: 120px;
    line-height: 25px;
    border: 1px solid #D8D8D8;
    text-align: center;
    margin-left: 5px;
    margin-top: 5px;
    margin-bottom: 5px;
    cursor: pointer;
    float: left;
    font-size: 16px;
}
</style>
